export const OC_PRODUCTS_CATALOG_HOME_PAGE = {
  desktop: `
<div class="cui cui-grid cui-container">

  <div class="display-none display-md-block">
    <div class="cui-skeleton-heading -size--extra-large -resolution--desktop -spacing--top-80 -spacing--bottom-64">
      <div class="cui-skeleton-heading__content" style="width:100%">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>  
  </div>

  <div class="display-block display-md-none">
    <div class="cui-skeleton-heading -size--extra-large -resolution--mobile -spacing--top-24 -spacing--bottom-40">
      <div class="cui-skeleton-heading__content" style="width:100%">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
  </div>

  <div class="cui-row -spacing--bottom-48">
    <div class="cui-col-lg-8">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 120px;"></div>
      </div>
    </div>
  </div>

  <div class="cui-row -gap--v-40">
    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 160px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
      </div>
    </div>

  </div>

  <div class="display-none display-md-block -spacing--top-120 -spacing--bottom-40">
    <div class="cui-skeleton-heading -size--large -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width:300px">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
  </div>

  <div class="display-block display-md-none -spacing--top-80 -spacing--bottom-16">
    <div class="cui-skeleton-heading -size--large -resolution--mobile">
      <div class="cui-skeleton-heading__content" style="width:200px">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
  </div>

  <div class="cui-row -gap--v-16">
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>
  </div>

  <div class="display-none display-md-block -spacing--top-120 -spacing--bottom-40">
    <div class="cui-skeleton-heading -size--large -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width:300px">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
  </div>

  <div class="display-block display-md-none -spacing--top-48 -spacing--bottom-16">
    <div class="cui-skeleton-heading -size--large -resolution--mobile">
      <div class="cui-skeleton-heading__content" style="width:200px">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
  </div>

  <div class="cui-row -gap--v-16 -spacing--bottom-160">
    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>

    <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-2">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 370px;"></div>
      </div>
    </div>
  </div>

</div>
`
};
